export default __webpack_public_path__ + "static/memories-51216f89ad362913aeb32091c9a4a842.png";